module.exports = __webpack_public_path__ + "static/media/arrow-up.0df99b8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-up.svg
// module id = 284
// module chunks = 7